import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[htcViewContainerDirective]',
})
export class ViewContainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
